<template>
  <div class="filters">
    <div class="accent--text mb-5 text-h6">
      <v-icon size="20" left color="accent" class="vertical-align-text-top"
        >mdi-filter</v-icon
      >
      Filters
    </div>

    <v-select
      clearable
      label="Category"
      dense
      v-model="category"
      :items="selectItems.categories"
      outlined
    ></v-select>
    <v-select
      clearable
      label="Type"
      dense
      v-model="product_type"
      :items="selectItems.product_types"
      outlined
    ></v-select>
    <!--    <v-select-->
    <!--      clearable-->
    <!--      v-model="discontinued"-->
    <!--      label="Validated"-->
    <!--      dense-->
    <!--      item-text="label"-->
    <!--      item-value="value"-->
    <!--      :items="[-->
    <!--        { value: 1, label: 'Yes' },-->
    <!--        { value: 0, label: 'No' }-->
    <!--      ]"-->
    <!--      outlined-->
    <!--    ></v-select>    -->
    <v-select
      clearable
      v-model="discontinued"
      label="Discontinued"
      dense
      item-text="label"
      item-value="value"
      :items="[
        { value: 1, label: 'Yes' },
        { value: 0, label: 'No' }
      ]"
      outlined
    ></v-select>
    <v-select
      clearable
      v-model="validated"
      label="Validated"
      dense
      item-text="label"
      item-value="value"
      :items="[
        { value: 'true', label: 'Yes' },
        { value: 'false', label: 'No' }
      ]"
      outlined
    ></v-select>
    <!-- <v-select
      clearable
      v-model="validated"
      label="Validated"
      dense
      item-text="label"
      item-value="value"
      :items="[
        { value: 1, label: 'Yes' },
        { value: 0, label: 'No' }
      ]"
      outlined
    ></v-select> -->
    <v-select
      clearable
      v-model="status"
      label="Request Status"
      dense
      item-text="label"
      item-value="value"
      :items="selectItems.proposal_status"
      outlined
    ></v-select>
    <v-select
      v-model="gender"
      label="Gender"
      clearable
      dense
      :items="selectItems.genders"
      outlined
    ></v-select>
    <!-- <v-slide-y-transition mode="in-out">
      <div v-if="$store.getters.isUserAdmin">
        <div class="grey--text mb-5">
          <v-icon left>mdi-account-tie</v-icon> <span>Admin filters</span>
        </div>
        <BrandInput multiple v-model="brand_id"></BrandInput>
      </div>
    </v-slide-y-transition> -->
    <!-- <v-menu
      ref="menu1"
      :close-on-content-click="false"
      :return-value.sync="launched_at"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          dense
          clearable
          outlined
          v-model="launched_at"
          label="Pick a date"
          prepend-inner-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker v-model="launched_at" no-title scrollable>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="menu = false">
          Cancel
        </v-btn>
        <v-btn text color="primary" @click="$refs.menu1.save(launched_at)">
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>
    <v-menu
      ref="menu"
      :close-on-content-click="false"
      :return-value.sync="discontinued_at"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          dense
          clearable
          outlined
          v-model="discontinued_at"
          label="Pick a date"
          prepend-inner-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker v-model="discontinued_at" no-title scrollable>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="menu = false">
          Cancel
        </v-btn>
        <v-btn text color="primary" @click="$refs.menu.save(discontinued_at)">
          OK
        </v-btn>
      </v-date-picker>
    </v-menu> -->
  </div>
</template>

<script>
import { capitalize } from "lodash"
import {
  GENDERS,
  PRODUCT_CATEGORIES,
  PRODUCT_TYPES,
  PROPOSAL_STATUS
} from "@/data"
export default {
  components: {
  },
  data() {
    return {
      selectItems: {
        product_types: PRODUCT_TYPES,
        genders: GENDERS,
        categories: PRODUCT_CATEGORIES,
        proposal_status: Object.keys(PROPOSAL_STATUS)
          .filter(k => !["CANCELLED"].includes(k))
          .map(k => ({
            value: PROPOSAL_STATUS[k],
            label: capitalize(PROPOSAL_STATUS[k].replace("_REQUEST", ""))
          }))
      }
    }
  },
  computed: {
    brand_id: {
      get() {
        return this.$store.state.catalogFilters.brand_id
      },
      set(v) {
        this.$store.commit("setCatalogFiltersValue", {
          attr: "brand_id",
          value: v
        })
      }
    },
    category: {
      get() {
        return this.$store.state.catalogFilters.category
      },
      set(v) {
        this.$store.commit("setCatalogFiltersValue", {
          attr: "category",
          value: v
        })
      }
    },
    product_type: {
      get() {
        return this.$store.state.catalogFilters.product_type
      },
      set(v) {
        this.$store.commit("setCatalogFiltersValue", {
          attr: "product_type",
          value: v
        })
      }
    },
    status: {
      get() {
        return this.$store.state.catalogFilters.status
      },
      set(v) {
        this.$store.commit("setCatalogFiltersValue", {
          attr: "status",
          value: v
        })
      }
    },
    discontinued: {
      get() {
        return this.$store.state.catalogFilters.discontinued
      },
      set(v) {
        this.$store.commit("setCatalogFiltersValue", {
          attr: "discontinued",
          value: v
        })
      }
    },
    validated: {
      get() {
        return this.$store.state.catalogFilters.validated
      },
      set(v) {
        this.$store.commit("setCatalogFiltersValue", {
          attr: "validated",
          value: v
        })
      }
    },
    gender: {
      get() {
        return this.$store.state.catalogFilters.gender
      },
      set(v) {
        this.$store.commit("setCatalogFiltersValue", {
          attr: "gender",
          value: v
        })
      }
    },
    launched_at: {
      get() {
        return this.$store.state.catalogFilters.launched_at
      },
      set(v) {
        this.$store.commit("setCatalogFiltersValue", {
          attr: "launched_at",
          value: v
        })
      }
    },
    discontinued_at: {
      get() {
        return this.$store.state.catalogFilters.discontinued_at
      },
      set(v) {
        this.$store.commit("setCatalogFiltersValue", {
          attr: "discontinued_at",
          value: v
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
